<template>
  <modal :show="localShow" :fullscreen="true" @close="close">
    <v-flex slot="title">Edycja</v-flex>

    <div>
      <v-layout column>
        <v-flex xs12>
          <w-schema :model="$schema.name">
            <v-text-field name="name" label="Nazwa Partnera *"></v-text-field>
          </w-schema>
        </v-flex>

        <v-flex xs12>
          <v-layout row wrap>
            <v-flex pr-2 xs6>
              <w-schema :model="$schema.email">
                <v-text-field name="email" label="Adres e-mail"></v-text-field>
              </w-schema>
            </v-flex>

            <v-flex pr-2 xs6>
              <w-schema :model="$schema.website">
                <v-text-field name="website" label="Strona internetowa"></v-text-field>
              </w-schema>
            </v-flex>
          </v-layout>
        </v-flex>

        <teryt-form v-if="show" :schema="$schema" :row="true"></teryt-form>

        <v-flex xs12>
          <v-layout row wrap>
            <v-flex pr-2 xs6>
              <w-schema :model="$schema.homeNumber">
                <v-text-field name="homeNumber" label="Numer budynku"></v-text-field>
              </w-schema>
            </v-flex>

            <v-flex pl-2 xs6>
              <w-schema :model="$schema.localNumber">
                <v-text-field name="localNumber" label="Numer lokalu"></v-text-field>
              </w-schema>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12>
          <w-schema :model="$schema.postalCode">
            <v-text-field name="postalCode" label="Kod pocztowy"></v-text-field>
          </w-schema>
        </v-flex>

        <v-flex v-if="show" class="mb-4" xs12>
          <html-editor :schema="$schema.description"></html-editor>
        </v-flex>

        <v-flex xs12>
          <w-schema :model="$schema.descriptionShort">
            <v-textarea label="Opis skrócony"></v-textarea>
          </w-schema>
        </v-flex>
      </v-layout>

      <v-flex v-if="show">
        <v-layout row wrap>
          <v-flex xs12 md6>
            <single-image :schema="$schema.mainImage"></single-image>
          </v-flex>
          <v-flex xs12 md6>
            <images-list :schema="$schema.images"></images-list>
          </v-flex>
        </v-layout>
      </v-flex>
    </div>

    <v-layout slot="actions">
      <v-spacer></v-spacer>

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="update">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import { schemaMixin, WSchema } from '@witkac/vuetify-components';

import Modal from '@/components/material/Modal';
import TerytForm from '@/components/forms/TERYTForm';
import HtmlEditor from '@/components/forms/HtmlEditor';
import SingleImage from '@/components/forms/SingleImage';
import ImagesList from '@/components/forms/ImagesList';
import schema from '@/schemas/partner.schema';
import { notificationsMixin } from '@/mixins/notifications';

const emptyData = {
  name: undefined,
  email: undefined,
  website: undefined,
  street: undefined,
  city: undefined,
  postalCode: undefined,
  description: undefined,
  woj: undefined,
  pow: undefined,
  gmi: undefined,
  terc: undefined,
  city: undefined,
  simc: undefined,
  street: undefined,
  ulic: undefined,
  descriptionShort: undefined
};

// @vuese
// Modal edycji Partnera
// @group Partners
export default {
  components: { Modal, WSchema, HtmlEditor, ImagesList, SingleImage, TerytForm },
  mixins: [schemaMixin, notificationsMixin],
  schema,
  props: {
    // Boolean kontrolujący widoczność modala
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    // Dane Partnera do edycji
    partnerToEdit: {
      type: Object,
      required: true,
      default: undefined
    }
  },
  data() {
    return {
      model: { ...emptyData },
      localShow: false
    };
  },
  methods: {
    // @vuese
    // Potwierdzenie zamknięcia formularza w przypadku zmian
    close() {
      if (this.$schema.$dirtyList().length !== 0) {
        this.$store.dispatch('showConfirmDialog');
      } else {
        this.closeModal();
      }
    },
    // @vuese
    // Funkcja emituje event `close` do zamknięcia modalu
    closeModal() {
      // Zamyka modal
      this.$emit('close');
    },
    // @vuese
    // Metoda aktualizuje dane Partnera
    update() {
      if (!this.$schema.$validateAll().length) {
        this.$emit('update', {
          id: this.partnerToEdit.id,
          ...this.model,
          state: this.partnerToEdit.state,
          benefitsCount: this.partnerToEdit.benefitsCount
        });
        this.closeModal();
      } else {
        this.notifyError('Błędnie wypełniony formularz');
      }
    },
    // @vuese
    // Metoda ustawia pola formularza
    setInputs() {
      this.$schema.$setData({ ...this.partnerToEdit });
    }
  },
  watch: {
    show(val) {
      this.localShow = val;
      if (val) {
        this.setInputs();
      }
    }
  }
};
</script>
